import ClusterDetailPage, { getServerSideProps } from './index';

export { getServerSideProps };
export default ClusterDetailPage;
